function getCityValue(item) {
  return typeof item === "string" ? item : item?.city;
}

export function sortedUniqueCities(source) {
  if (!source?.length) return [];

  return [...new Set(source.map(getCityValue).filter((city) => city != null && city !== ""))].sort((a, b) =>
    `${a}`.localeCompare(`${b}`, undefined, { sensitivity: "base" })
  );
}
